export const ADMIN_OMNIBAR_DESTINATIONS = [
  {
    id: 'dest-overview',
    kind: 'destination',
    label: 'Overview',
    description: 'Page',
    href: '/admin/overview',
    searchHaystack: 'overview home growth signups',
  },
  {
    id: 'dest-users',
    kind: 'destination',
    label: 'Users',
    description: 'Page',
    href: '/admin/users',
    searchHaystack: 'users signups brands influencers',
  },
  {
    id: 'dest-locations',
    kind: 'destination',
    label: 'Locations',
    description: 'Page',
    href: '/admin/locations',
    searchHaystack: 'locations influencers cities states city state geography',
  },
  {
    id: 'dest-active-users',
    kind: 'destination',
    label: 'Active users',
    description: 'Page',
    href: '/admin/active-users',
    searchHaystack: 'active users last active recently used login',
  },
  {
    id: 'dest-collaborations',
    kind: 'destination',
    label: 'Collaborations',
    description: 'Page',
    href: '/admin/collaborations',
    searchHaystack: 'collaborations applications invites',
  },
  {
    id: 'dest-campaigns',
    kind: 'destination',
    label: 'Campaigns',
    description: 'Page',
    href: '/admin/campaigns',
    searchHaystack: 'campaigns active upcoming archived',
  },
  {
    id: 'dest-payments',
    kind: 'destination',
    label: 'Payments',
    description: 'Page',
    href: '/admin/payments',
    searchHaystack: 'payments millet fee revenue checkout payouts',
  },
];

export function buildAdminUsersSearchLocation(keyword) {
  const trimmed = String(keyword || '').trim();
  const params = new URLSearchParams();
  if (trimmed) params.set('search', trimmed);
  const query = params.toString();
  return {
    pathname: '/admin/users',
    search: query ? `?${query}` : '',
  };
}
